<template>
  <button
    :class="buttonClass"
    :disabled="disabled"
    :type="type"
    @click.prevent.stop="handleClick"
  >
    <span :class="content">
      <slot />
      <span v-if="!$slots.default">
        <i
          v-if="icon"
          :class="[icon, $style.icon]"
        />
        <component
          :is="iconComponent"
          v-if="iconComponent"
          :class="$style.icon"
        />
        <span :class="$style.text">{{ text }}</span>
      </span>
    </span>
    <transition
      :enterActiveClass="$style.fadeEnterActive"
      :enterClass="$style.fadeTo"
      :leaveActiveClass="$style.fadeLeaveActive"
      :leaveToClass="$style.fadeTo"
    >
      <div
        v-if="loading"
        :class="$style.loadingContent"
      >
        <LoadingIcon :class="$style.loadingIcon" />
      </div>
    </transition>
  </button>
</template>

<script>
import LoadingIcon from 'components/LoadingOverlay/LoadingIcon.vue';

export default {
  name: 'FlatActionButton',

  components: {
    LoadingIcon,
  },

  props: {
    action: {
      type: Function,
      default: () => {},
      required: true,
    },
    // TODO: add a validator perhaps
    buttonClass: {
      type: [String, Array],
      default: 'btnDefault',
    },
    disabled: {
      default: false,
      required: false,
      type: Boolean,
    },
    icon: {
      default: '',
      type: String,
    },
    iconComponent: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
      type: Boolean,
    },
    text: {
      default: '',
      type: String,
    },
    type: {
      default: 'button',
      type: String,
    },
  },

  computed: {
    content() {
      const { content, fadeLeaveTo } = this.$style;
      const classes = [content];
      if (this.loading) {
        classes.push(fadeLeaveTo);
      }
      return classes;
    },
  },

  methods: {
    /**
     * Simple click handler that prevents multiple submissions
     */
    handleClick(event) {
      if (!this.loading) {
        this.action(event);
      }
    },
  },
};

</script>
<style module scoped>
@import './FlatActionStyles.css';

@value (jcGrey400) from '~css/brand-colors.css';
@value (buttonContentFade, fadeTransition) from '~css/transitions.css';
@value plusSignZIndex from '~css/z-index.css';

.fadeTo,
.fadeLeaveTo {
  opacity: 0;
}

.fadeEnterActive,
.fadeEnter {
  transition: fadeTransition;
}

.fadeLeaveActive {
  transition: buttonContentLeave;
}

.loadingContent {
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
}

.loadingIcon {
  fill: jcGrey400;
  height: 18px;
  width: 18px;
}
</style>
